var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 97,
    viewBox: "0 0 268 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.3884,
    y: 5.99992,
    width: 63.147,
    height: 95.1415,
    rx: 5.56007,
    transform: "rotate(19.2636 14.3884 5.99992)",
    fill: "#68B4F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.8198,
    y: 50.5761,
    width: 37.8592,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(19.26 13.8198 50.5761)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1738,
    y: 55.5145,
    width: 31.8649,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(19.26 12.1738 55.5145)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.979,
    y: 61.0014,
    width: 35.5283,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(19.26 9.979 61.0014)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7581,
    y: 30.8233,
    width: 37.8592,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(19.26 18.7581 30.8233)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1121,
    y: 35.7612,
    width: 31.8649,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(19.26 17.1121 35.7612)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.9172,
    y: 41.2481,
    width: 35.5283,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(19.26 14.9172 41.2481)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.922,
    y: 40.7247,
    width: 63.147,
    height: 95.1415,
    rx: 5.56007,
    transform: "rotate(-23.8283 182.922 40.7247)",
    fill: "#E2F2FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.96,
    y: 73.6652,
    width: 37.8592,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(-23.8319 212.96 73.6652)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.131,
    y: 78.396,
    width: 31.8649,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(-23.8319 215.131 78.396)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.277,
    y: 83.9023,
    width: 35.5283,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(-23.8319 217.277 83.9023)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.071,
    y: 55.867,
    width: 37.8592,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(-23.8319 203.071 55.867)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.243,
    y: 60.5975,
    width: 31.8649,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(-23.8319 205.243 60.5975)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.388,
    y: 66.1037,
    width: 35.5283,
    height: 2.19474,
    rx: 0.926679,
    transform: "rotate(-23.8319 207.388 66.1037)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.903,
    y: 12.4421,
    width: 63.147,
    height: 95.1415,
    rx: 5.56007,
    transform: "rotate(9.17511 130.903 12.4421)",
    fill: "#80C3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.755,
    y: 62.2666,
    width: 36.2383,
    height: 2.10077,
    rx: 0.887004,
    transform: "rotate(9.1715 136.755 62.2666)",
    fill: "white",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.031,
    y: 67.196,
    width: 30.5007,
    height: 2.10077,
    rx: 0.887004,
    transform: "rotate(9.1715 136.031 67.196)",
    fill: "white",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.883,
    y: 72.7345,
    width: 34.0071,
    height: 2.10077,
    rx: 0.887004,
    transform: "rotate(9.1715 134.883 72.7345)",
    fill: "white",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.83 29.4797C145.562 29.1299 143.411 30.7055 143.062 32.9737L140.166 51.7509C139.816 54.019 141.392 56.1692 143.66 56.519L162.437 59.4146C164.705 59.7644 166.856 58.1888 167.205 55.9207L170.101 37.1434C170.451 34.8753 168.875 32.7251 166.607 32.3754L147.83 29.4797ZM147.482 31.733L166.26 34.6286C167.31 34.7906 168.01 35.7457 167.848 36.7959L165.478 52.1595L161.637 47.0946C161.636 47.094 161.636 47.0935 161.636 47.0929C161.138 46.4385 160.416 46.0307 159.655 45.9134C158.894 45.7961 158.082 45.9672 157.41 46.4428L155.642 47.6945L151.693 42.4883C151.197 41.833 150.476 41.422 149.711 41.3042C148.946 41.1861 148.136 41.3627 147.467 41.8351C147.466 41.8355 147.466 41.8359 147.465 41.8364L143.578 44.5875L145.315 33.3211C145.477 32.2709 146.432 31.571 147.482 31.733ZM161.29 36.938C160.257 36.7788 159.274 37.0652 158.591 37.6302C157.908 38.1952 157.514 38.9831 157.389 39.7967C157.263 40.6104 157.401 41.4802 157.882 42.2248C158.363 42.9693 159.214 43.5386 160.247 43.6979C161.28 43.8571 162.263 43.5707 162.946 43.0057C163.629 42.4407 164.023 41.6529 164.148 40.8392C164.274 40.0255 164.136 39.1557 163.655 38.4111C163.174 37.6666 162.322 37.0973 161.29 36.938ZM160.942 39.1913C161.412 39.2637 161.6 39.4315 161.74 39.6477C161.88 39.864 161.943 40.1787 161.895 40.4917C161.847 40.8046 161.691 41.0856 161.493 41.2497C161.294 41.4138 161.064 41.517 160.595 41.4446C160.125 41.3722 159.937 41.2044 159.797 40.9882C159.657 40.7719 159.594 40.4572 159.642 40.1442C159.69 39.8313 159.846 39.5504 160.044 39.3862C160.242 39.2221 160.473 39.1189 160.942 39.1913ZM149.364 43.5574C149.559 43.5876 149.741 43.6877 149.875 43.8646C149.876 43.8651 149.876 43.8657 149.876 43.8663L153.779 49.0113L145.934 54.5627L144.007 54.2657C142.957 54.1037 142.257 53.1486 142.419 52.0984L143.094 47.7224L148.782 43.6975C148.966 43.5677 149.17 43.5275 149.364 43.5574ZM159.307 48.1666C159.506 48.1973 159.686 48.296 159.82 48.4725L164.995 55.2945L164.952 55.5732C164.79 56.6234 163.835 57.3233 162.785 57.1614L149.176 55.0627L158.727 48.304C158.906 48.1773 159.109 48.1361 159.307 48.1666Z",
    fill: "white",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50.6203,
    width: 62.5933,
    height: 94.3073,
    rx: 5.51133,
    transform: "rotate(-18.2676 50 50.6203)",
    fill: "#B5DFFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9903 61.1558C73.7056 61.8828 72.4262 64.3563 73.1531 66.641L79.1713 85.5558C79.8982 87.8405 82.3718 89.1199 84.6565 88.393L103.571 82.3748C105.856 81.6479 107.135 79.1743 106.408 76.8896L100.39 57.9749C99.6633 55.6902 97.1898 54.4107 94.9051 55.1376L75.9903 61.1558ZM76.7125 63.4256L95.6272 57.4074C96.6851 57.0708 97.7839 57.6392 98.1205 58.6971L103.045 74.1731L97.096 71.2197C97.0954 71.2194 97.0947 71.219 97.0941 71.2187C96.3245 70.8376 95.459 70.7918 94.6926 71.0357C93.9264 71.2795 93.2465 71.8169 92.8388 72.5743L91.7659 74.5673L85.6512 71.5317C84.8825 71.149 84.0168 71.0997 83.2468 71.3447C82.4756 71.5901 81.7997 72.1319 81.3934 72.8848C81.3931 72.8854 81.3928 72.8861 81.3924 72.8867L79.0338 77.2677L75.4229 65.9189C75.0863 64.861 75.6546 63.7622 76.7125 63.4256ZM92.0506 61.8781C91.0103 62.2091 90.2235 62.9341 89.8471 63.7802C89.4706 64.6263 89.4684 65.5464 89.7292 66.366C89.99 67.1857 90.5235 67.9354 91.3196 68.4084C92.1158 68.8814 93.1768 69.0184 94.2172 68.6874C95.2575 68.3564 96.0443 67.6315 96.4207 66.7854C96.7971 65.9392 96.7993 65.0191 96.5385 64.1995C96.2777 63.3799 95.7443 62.6302 94.9481 62.1572C94.152 61.6841 93.0909 61.5471 92.0506 61.8781ZM92.7728 64.1479C93.2457 63.9974 93.5 64.0668 93.7313 64.2042C93.9625 64.3416 94.1685 64.6064 94.2688 64.9217C94.3691 65.2369 94.3541 65.5721 94.2447 65.8178C94.1354 66.0636 93.9678 66.2672 93.495 66.4177C93.0221 66.5681 92.7677 66.4988 92.5365 66.3614C92.3052 66.224 92.0993 65.9591 91.999 65.6439C91.8987 65.3286 91.9137 64.9935 92.023 64.7477C92.1324 64.5019 92.2999 64.2983 92.7728 64.1479ZM83.9689 73.6145C84.1659 73.5518 84.3826 73.5609 84.5901 73.6642C84.5908 73.6645 84.5914 73.6649 84.5921 73.6652L90.6351 76.6651L85.8746 85.5059L83.9343 86.1232C82.8764 86.4598 81.7776 85.8915 81.441 84.8336L80.0385 80.4256L83.4897 74.016C83.6013 73.8092 83.7732 73.6768 83.9689 73.6145ZM95.4147 73.3055C95.6152 73.2417 95.8294 73.2504 96.0369 73.3532L104.049 77.331L104.139 77.6118C104.475 78.6697 103.907 79.7685 102.849 80.1051L89.1403 84.4668L94.936 73.7035C95.0447 73.5017 95.2155 73.3689 95.4147 73.3055Z",
    fill: "white",
    fillOpacity: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4785,
    height: 36.4785,
    fill: "white",
    transform: "translate(139.887 23.6411) rotate(8.76659)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.1102,
    height: 38.1102,
    fill: "white",
    transform: "translate(65.8452 59.3845) rotate(-17.6497)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTemplate);
export default __webpack_public_path__ + "static/media/new-template.585c03063c44e387ad88662eb480980b.svg";
export { ForwardRef as ReactComponent };